




































































































































import { Component, Watch } from 'vue-property-decorator';

import { ComponenteBase } from '@/views/base/ComponenteBase';
import { LoadingService } from '@/services/loadingService';
import { Funcionalidades } from '@/config/funcionalidades';
const { AgGridVue } = require('ag-grid-vue');
import {
  GridOptions,
  GridApi,
  GridReadyEvent,
  ICellRendererParams,
  ColDef,
  ColumnApi,
  CellClickedEvent,
} from 'ag-grid-community';

import FormFieldsContainer from '@/reusable/Form/FormFieldsContainer.vue';
import {
  PermisoAccion,
  codigoAccionesMenuItem as consultaInstalaciones,
} from '@/views/base/VariablesPermisos';
import store from '@/store';
import { actionsEvent } from '@/setup';
import MenuItem from '@/components/MenuItem.vue';
import DatePicker from '@/reusable/Form/DatePicker.vue';
import moment from 'moment';

import { fetchConsultaInstalaciones } from './fetchConsultaInstalaciones';
import { getUserId } from '../MantenedorLocalidad/helpers/getUserId';
import { today } from './helpers/getDay';
import PopUpGeneratedReports from './PopUpGeneratedReoports.vue';
import {
  ParamsApi,
  GetFilters,
  ParamsFindFilter,
} from '@/pantallas/Conecta/ConsultaInstalaciones/models/ConsultaInstalacionesBaseModels';

@Component({
  components: {
    GridComponent: AgGridVue,
    FormFieldsContainer,
    DatePicker,
    PopUpGeneratedReports,
  },
})
export default class ConsultaInstalacionesBase extends ComponenteBase {
  readonly funcionalidad: Funcionalidades =
    Funcionalidades.ConsultaInstalaciones;
  readonly accionesTotales: PermisoAccion[] = [];
  readonly loadingService = new LoadingService();
  readonly codigoAccionesMenuItem: number[] = Object.values(
    consultaInstalaciones
  );

  columnApi: any = null;
  gridOptions: GridOptions = null;
  gridEvent: any = null;
  gridApi: GridApi = null;
  serverSide: any = null;
  columnDefs: ColDef[] = [];

  acitvateChange: boolean = false;
  showPopUpReport: boolean = false;

  msgReport: string = '';
  today: string = today();

  filter: GetFilters = {};
  objectParam: ParamsApi = {
    start_date: moment().subtract(1, 'months'),
    end_date: moment(),
    altasernumero: '',
    coorid: '',
    tipoeqid: '',
    serienumero: '',
    clienterut: '',
    otro_cliente_preparacion: false,
  };

  constructor() {
    super();
    this.columnDefs = this.colsGrid();

    this.gridOptions = {
      columnDefs: this.columnDefs,
      pagination: true,
      domLayout: 'autoHeight',
      paginationPageSize: 50,
      cacheBlockSize: 50,
      overlayNoRowsTemplate: 'No hay filas para mostrar',

      rowModelType: 'serverSide',
      serverSideDatasource: this.serverSide,
      onGridReady: this.handleMainGridReady,
    };
  }

  private colsGrid(): ColDef[] {
    const colsId = [
      'Fecha Instalación',
      'Coordinador',
      'Técnico',
      'Orden de Servicio de Instalación',
      'Tipo de Equipo',
      'Serie Número',
      'SIM Número',
      'Cliente Instalación',
      'Flota',
      'Patente',
      'Requerimiento Preparación',
      'Cliente Preparación',
      'Fecha Preparación',
      'EPC',
      'Modalidad',
      'Marca Vehículo',
      'Modelo Vehículo',
      'Año Vehículo',
    ];

    const cols: ColDef[] = colsId.map(col => ({
      headerName: col,
      field: col,
      cellStyle: { textAlign: 'left' },
      resizable: true,
      width: 220,
      minWidth: 100,
    }));

    return cols;
  }

  async handleMainGridReady(event: GridReadyEvent): Promise<void> {
    this.filter = await this.getFilters();
    this.gridApi = event.api;
    this.columnApi = event.columnApi;
    this.gridEvent = event;
    const self: this = this;

    this.serverSide = {
      async getRows(params: any): Promise<void> {
        params.request.paginationSize = self.gridOptions.cacheBlockSize;
        const paramsApi: any = {};
        for (const key in self.objectParam) {
          if (
            self.objectParam.hasOwnProperty(key) &&
            self.objectParam[key as keyof ParamsApi]
          ) {
            paramsApi[key] = self.objectParam[key as keyof ParamsApi];
          }
        }
        const objectApi = Object.assign({}, paramsApi, params.request);
        self.loadingService.showLoading();

        await fetchConsultaInstalaciones({ ...objectApi }, 'get_all')
          .then(response => {
            const {
              CODIGO_RESPUESTA,
              MENSAJE_RESPUESTA,
              LISTA,
            } = response.data;

            if (CODIGO_RESPUESTA != '1') {
              self.$snotify.error(MENSAJE_RESPUESTA, { timeout: 3500 });
              params.successCallback([{}], 0);
              self.gridApi.showNoRowsOverlay();
              return;
            }
            if (MENSAJE_RESPUESTA === 'SIN DATA') {
              self.$snotify.error(MENSAJE_RESPUESTA, { timeout: 3500 });
              params.successCallback([{}], 0);
              self.gridApi.showNoRowsOverlay();
              return;
            }
            params.successCallback(LISTA, LISTA[0].total_registros);
          })
          .catch((error: Error) => {
            self.$snotify.error(
              'Ocurrió un error inesperado, por favor reintente un poco más tarde.',
              {
                timeout: 3500,
              }
            );
            throw error;
          })
          .finally(() => {
            self.loadingService.hideLoading();
          });
      },
    };
    this.reloadGrid();
  }

  async reloadGrid(clear: boolean = false): Promise<void> {
    if (clear) await this.clear();
    await new Promise(resolve => setTimeout(resolve, 100));
    this.gridApi.setServerSideDatasource(this.serverSide);
    this.gridApi.setDomLayout('autoHeight');
  }

  @Watch('objectParam.start_date')
  startDateChange() {
    if (this.objectParam.start_date > this.objectParam.end_date) {
      this.objectParam.end_date = this.objectParam.start_date;
    }
    this.handleFilters();
  }

  @Watch('objectParam.end_date')
  endDateChange() {
    if (this.objectParam.end_date < this.objectParam.start_date) {
      this.objectParam.start_date = this.objectParam.end_date;
    }
    this.handleFilters();
  }

  handleSearchFilter(): void {
    const entries = Object.entries(this.objectParam);
    const hasValue = entries.some(
      ([key, value]: [string, ParamsApi]) => key !== 'serienumero' || value
    );
    if (this.objectParam.serienumero) {
      this.acitvateChange = false;
      this.reloadGrid();
      return;
    }
    if (hasValue) {
      this.acitvateChange = true;
      this.handleFilters();
      return;
    }
  }

  handleClearFilter(): void {
    if (
      this.acitvateChange ||
      this.objectParam.serienumero ||
      this.objectParam.start_date === this.objectParam.end_date
    ) {
      this.reloadGrid(true);
      return;
    }
    this.clear();
  }

  handleFilters(): void {
    if (this.objectParam.serienumero) {
      this.acitvateChange = false;
    }
    if (this.acitvateChange) {
      this.reloadGrid();
    }
  }

  handleCloseReport(): void {
    this.showPopUpReport = false;
    this.msgReport = '';
  }

  clear(): void {
    this.acitvateChange = false;
    this.objectParam = Object.fromEntries(
      Object.keys(this.objectParam).map(key => [key, ''])
    );
    this.objectParam.start_date = moment().subtract(1, 'months');
    this.objectParam.end_date = moment();
  }

  async getFilters(): Promise<GetFilters> {
    const self: this = this;
    self.loadingService.showLoading();

    return await fetchConsultaInstalaciones({}, 'get_filters')
      .then(response => {
        const { CODIGO_RESPUESTA, MENSAJE_RESPUESTA, LISTA } = response.data;

        if (CODIGO_RESPUESTA != '1') {
          self.$snotify.error(MENSAJE_RESPUESTA, { timeout: 3500 });
          return;
        }
        if (MENSAJE_RESPUESTA === 'SIN DATA') {
          self.$snotify.error(MENSAJE_RESPUESTA, { timeout: 3500 });
          return;
        }
        return LISTA;
      })
      .catch((error: Error) => {
        self.$snotify.error(
          'Ha ocurrido un error inesperado, por favor intente más tarde',
          { timeout: 3500 }
        );
        throw error;
      })
      .finally(() => {
        self.loadingService.hideLoading();
      });
  }

  findFilter({ paramsApi, list, id, propName }: ParamsFindFilter): string {
    const obj = list.find((item: any) => item[id] === paramsApi[id]);
    return obj ? obj[propName] : '';
  }

  async getCSV(): Promise<void> {
    const self: this = this;
    self.loadingService.showLoading();
    const paramsApi: any = {};

    if (!self.acitvateChange && !self.objectParam.serienumero) {
      self.clear();
    }

    for (const key in self.objectParam) {
      if (self.objectParam[key as keyof ParamsApi]) {
        paramsApi[key] = self.objectParam[key as keyof ParamsApi];
      }
    }

    const filter: Record<string, string> = {};

    if (paramsApi.hasOwnProperty('altasernumero')) {
      filter.altaserorden_numero = self.findFilter({
        paramsApi,
        list: this.filter.orden_servicio,
        id: 'altasernumero',
        propName: 'altaserorden_numero',
      });
    }

    if (paramsApi.hasOwnProperty('coorid')) {
      filter.coorname = self.findFilter({
        paramsApi,
        list: self.filter.coordinadores,
        id: 'coorid',
        propName: 'coorname',
      });
    }

    if (paramsApi.hasOwnProperty('tipoeqid')) {
      filter.tipoeqname = self.findFilter({
        paramsApi,
        list: self.filter.equipos,
        id: 'tipoeqid',
        propName: 'tipoeqname',
      });
    }

    if (paramsApi.hasOwnProperty('clienterut')) {
      filter.instalacion_razon_social = self.findFilter({
        paramsApi,
        list: self.filter.cliente_instalado,
        id: 'clienterut',
        propName: 'instalacion_razon_social',
      });
    }

    const userId = getUserId();
    const user = localStorage.getItem('clienteDefecto');

    return await fetchConsultaInstalaciones(
      {
        userId,
        user,
        ...paramsApi,
        ...filter,
      },
      'export_excel'
    )
      .then(response => {
        const { CODIGO_RESPUESTA, MENSAJE_RESPUESTA } = response.data;
        if (CODIGO_RESPUESTA != '1') {
          self.$snotify.error(MENSAJE_RESPUESTA, { timeout: 3500 });
          return;
        }
        self.msgReport = MENSAJE_RESPUESTA;
        self.showPopUpReport = true;
      })
      .catch((error: Error) => {
        self.$snotify.error(
          'Ha ocurrido un error inesperado, por favor intente más tarde',
          { timeout: 3500 }
        );
        throw error;
      })
      .finally(() => {
        self.loadingService.hideLoading();
      });
  }
}
